<template>
  <div>
    <div class="col-sm-12 col-xs-12 form-group mt-10 mb-5">Add Sub Module</div>
    <div class="col-sm-6 col-xs-6 custom-dropdown">
      <multiselect
        :showLabels="false"
        :close-on-select="true"
        :allow-empty="false"
        class="multiselect-single-dropdown"
        :class="!selectedModule ? 'un-selected' : ''"
        :searchable="true"
        :options="serviceModule.modules.map((moduleName) => moduleName.name)"
        v-model="selectedModule"
        placeholder="Select Module"
      >
        <span slot="noResult">No matching data</span>
      </multiselect>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12">
      <div class="row label_container">
        <div class="checkbox mr-bt-0 cust_checkbox flex_grow_0">
          <input type="checkbox" class="form-control" v-model="operationAccess" />
          <label></label>
        </div>
        <input type="text" v-model="operationName" class="form-control" />
        <button
          type="button"
          class="btn emergo-green-button"
          :disabled="operationName.length <= 0 || selectedModule.length <= 0"
          @click="add"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['serviceModule'],
  data() {
    return {
      operationName: '',
      operationAccess: true,
      selectedModule: ''
    };
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    add() {
      let flag = false;
      this.serviceModule.modules.forEach((module) => {
        if (module.name === this.selectedModule) {
          module.operations.forEach((operation) => {
            if (operation.name.toLowerCase() === this.operationName.toLowerCase()) {
              flag = true;
            }
          });
          if (!flag) {
            module.operations.push({
              id: 0,
              name: this.operationName,
              access: this.operationAccess
            });
          } else {
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: 'Error',
              text: `Sub Module Already Exists! in ${this.selectedModule}`,
              group: 'custom-notification'
            });
          }
        }
      });
      this.operationName = '';
    }
  }
};
</script>
<style scoped lang="scss">
.custom-dropdown {
  padding: 4px 1px 2px 15px;
}
.label_container {
  display: flex;
  align-items: center;
  margin-left: 1px;
  padding: 7px 10px 5px 0px;
  border-bottom: 0.5px solid $gray74;
}
.label_container {
  > button {
    width: 25%;
    margin-left: 5px;
  }
}
.form-control {
  width: 45%;
}
.form-group {
  &.mb-5 {
    margin-bottom: 5px;
  }
}
</style>
